<modal-layout-right (close)="close()">
    <ng-container ngProjectAs="[modalTitle]">
        <h4 class="h3">{{'Select your sizes' | translate}}</h4>
    </ng-container>

    <div modalBody
         class="p-a p-t-5"
         [style.width]="client.sizeId > 1 ? '480px' : '100%'">
        @for(selection of selectedProducts; track $index) {
        <builder-product-configurable-selection class="m-b-2 block"
                                                [model]="selection.product"
                                                [existingSelection]="selection.configurableSelection"
                                                [preselectSingles]="true"
                                                [preselectOptions]="['color']"
                                                (selectionChange)="onSelectionChange(selection.selectionId, selection.product, $event.selection)"
                                                (onRemove)="removeProduct(selection.selectionId)">
        </builder-product-configurable-selection>
        }
    </div>

    <div modalFooter
         class="w-12 p-a flex flex-top">

        <div class="flex flex-middle"
             style="height: 48px;">
            <!-- final price -->
            <price class="s1 col-6 m-r-3"
                   [value]="totals.price"></price>
            @if (totals.org_price) {
            <price class="col-12 p1 inline-block line-through m-r-3"
                   [value]="totals.org_price"></price>
            }
        </div>

        <builder-add-to-basket class="flex-grow m-l-1"
                               [isDisabled]="!canAddToBasket"
                               [basketRequest]="data.basketRequest"
                               [storageData]="data.storageData"
                               [isPreset]="true"></builder-add-to-basket>
    </div>
</modal-layout-right>
